var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "39-caution"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 3,
    x: 3,
    y: 7,
    fill: "#ad9990",
    rx: 1.5,
    opacity: 1,
    "data-original": "#ad9990"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 3,
    x: 53,
    y: 7,
    fill: "#ad9990",
    rx: 1.5,
    opacity: 1,
    "data-original": "#ad9990"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3c8be",
    d: "m54 10 1 3h4l1-3zM4 10l1 3h4l1-3z",
    opacity: 1,
    "data-original": "#a3c8be"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94350f",
    d: "M7 1a3 3 0 0 1 3 3v3H4V4a3 3 0 0 1 3-3zM57 1a3 3 0 0 1 3 3v3h-6V4a3 3 0 0 1 3-3z",
    opacity: 1,
    "data-original": "#94350f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9990",
    d: "M55 13h4v3h-4zM5 13h4v3H5zM5 30h4v4H5zM55 30h4v4h-4z",
    opacity: 1,
    "data-original": "#ad9990"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 3,
    x: 3,
    y: 60,
    fill: "#6e5f5c",
    rx: 1.5,
    opacity: 1,
    "data-original": "#6e5f5c"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 3,
    x: 53,
    y: 60,
    fill: "#6e5f5c",
    rx: 1.5,
    opacity: 1,
    "data-original": "#6e5f5c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9990",
    d: "M55 48h4v12h-4zM5 48h4v12H5z",
    opacity: 1,
    "data-original": "#ad9990"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffc630"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58 30 5-5v5zM1 24l8-8H1zM1 42l8-8H1zM23 16 9 30H2l14-14zM37 16 23 30h-7l14-14zM51 16 37 30h-7l14-14zM63 16v2L51 30h-7l14-14z",
    fill: "#ffc630",
    opacity: 1,
    "data-original": "#ffc630"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16 16 2 30H1v-6l8-8zM30 16 16 30H9l14-14zM44 16 30 30h-7l14-14zM58 16 44 30h-7l14-14zM58 30l5-5v-7L51 30z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc630",
    d: "m58 48 5-5v5zM23 34 9 48H2l14-14zM37 34 23 48h-7l14-14zM51 34 37 48h-7l14-14zM63 34v2L51 48h-7l14-14z",
    opacity: 1,
    "data-original": "#ffc630"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 34 2 48H1v-6l8-8zM30 34 16 48H9l14-14zM44 34 30 48h-7l14-14zM58 34 44 48h-7l14-14zM58 48l5-5v-7L51 48z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafety);
export default __webpack_public_path__ + "static/media/safety.3be4c6691945f0fe0eb4087f1c698e87.svg";
export { ForwardRef as ReactComponent };